import React from "react";

import CDCommonDeductionsForm from "./forms/CDCommonDeductionsForm";

const CommonDeductionsDetails: React.FC = () => {
	return (
		<>
			<CDCommonDeductionsForm />
		</>
	);
};

export default CommonDeductionsDetails;
